/* eslint-disable @typescript-eslint/no-var-requires */
import React, {
  FunctionComponent,
  MutableRefObject,
  useEffect,
  useRef,
  useState,
} from 'react';

import './animation011.less';
import { usePlayFlag } from './../../components/topicScroll';
import { Button, Modal } from 'antd';
import ImgPoint from '../../../../../assets/animation_point.gif';
import ImgArrowLeft from '../../../../../assets/arrow-left-long.png';
import ImgArrowRight from '../../../../../assets/arrow-right-long.png';

interface IAnimation011SubItem {
  img: string;
  title: string;
  content: string;
  tip: string;
}
interface IAnimation011Item {
  icon: string;
  text: string;
  tip?: string;
  subtitle?: string;
  subItems?: IAnimation011SubItem[];
}

interface IAnimation011Props {
  items: IAnimation011Item[];
  className?: string | null;
  onCompleted: () => void;
}

const Animation011: FunctionComponent<IAnimation011Props> = ({
  items,
  className,
  onCompleted,
}) => {
  const crrRef = useRef() as MutableRefObject<HTMLDivElement>;
  const playFlag = usePlayFlag(crrRef.current as HTMLElement, '.course-body');
  const [play, setPlay] = React.useState(1);
  const [modalItem, setModalItem] = React.useState<IAnimation011SubItem[]>();
  const [isModalOpen, setModalOpen] = useState(false);
  const [currPage, setCurrPage] = React.useState(0);
  const [show, setShow] = useState<number[]>([]);
  const [show1, setShow1] = React.useState<number[]>([]);
  const [show2, setShow2] = React.useState<number[]>([]);
  const setPage = (pagePlus: number) => {
    setCurrPage(currPage + pagePlus);
  };
  const startPlay = (next = 2) => {
    setPlay(next);
    next += 1;
    if (next <= items.length) {
      setTimeout(() => startPlay(next), 1200);
    } else {
      console.log('Animation011 onCompleted');
      onCompleted && onCompleted();
    }
  };
  const getImg = (img: string) =>
    require(`../../../../../assets/${img}`).default;

  useEffect(() => {
    if (playFlag && play <= 1) {
      startPlay();
    }
  }, [playFlag]);

  const clickToPlay = () => {
    if (play <= 1) {
      startPlay();
    }
  };
  return (
    <>
      <div ref={crrRef} className={`animation011 component ${className}`}>
        <img
          className="click-point"
          onClick={() => clickToPlay()}
          style={{
            display: play <= 1 ? 'block' : 'none',
          }}
          src={ImgPoint}
          alt=""
        />
        <div className="animation011-content" onClick={() => clickToPlay()}>
          {items.map((itm: IAnimation011Item, idx: number) => (
            <div
              key={idx}
              className={`animation011-item animation r${idx + 1} ${
                play >= idx + 1 ? 'fade-in' : ''
              }`}
              style={{ paddingLeft: idx * 100 }}
            >
              <div className="animation011-icon">
                <img src={getImg(itm.icon)} alt="" />
              </div>
              <div className="animation011-text">
                {itm.text}
                {itm.subtitle ? (
                  <span className="view-more">
                    <Button
                      className="view-more-btn"
                      onClick={() => {
                        setModalOpen(true);
                        setModalItem(itm.subItems);
                        setShow([...show, idx]);
                      }}
                      type="link"
                    >
                      {itm.subtitle}
                      <img
                        className="click-point1"
                        hidden={show.includes(idx)}
                        src={ImgPoint}
                        alt=""
                      />
                    </Button>
                  </span>
                ) : null}
              </div>
            </div>
          ))}
        </div>
      </div>
      {modalItem && (
        <Modal
          width="80%"
          className="animation011-modal-student"
          title={
            <div className="animation011-modal-header">
              {modalItem[currPage]?.title}
            </div>
          }
          footer={null}
          open={isModalOpen}
          onCancel={() => {
            setModalOpen(false);
            setCurrPage(0);
          }}
        >
          <div className="border">
            <img
              src={
                require(`../../../../../assets/${modalItem[currPage]?.img}`)
                  .default
              }
              alt=""
            />
          </div>
          {modalItem.length > 0 && modalItem[currPage]?.content && (
            <>
              <div
                className="tip"
                dangerouslySetInnerHTML={{
                  __html: modalItem[currPage]?.tip,
                }}
              />
              <div
                className="content"
                dangerouslySetInnerHTML={{
                  __html: modalItem[currPage]?.content,
                }}
              />
            </>
          )}
          <Button
            className={`prev-button ${currPage === 0 ? 'hide' : ''}`}
            type="text"
            disabled={currPage === 0}
            onClick={() => {
              setPage(-1);
              setShow2([...show2, currPage]);
            }}
          >
            <img className="arrow" src={ImgArrowLeft} alt="" />
            <img
              className="click-point1"
              hidden={!show}
              src={ImgPoint}
              alt=""
            />
          </Button>

          <Button
            className={`next-button ${
              currPage === modalItem.length - 1 ? 'hide' : ''
            }`}
            type="text"
            disabled={currPage === modalItem.length - 1}
            onClick={() => {
              setPage(1);
              setShow1([...show1, currPage]);
            }}
          >
            <img className="arrow" src={ImgArrowRight} alt="" />
            <img
              className="click-point2"
              hidden={show1.includes(currPage)}
              src={ImgPoint}
              alt=""
            />
          </Button>
        </Modal>
      )}
    </>
  );
};

export default Animation011;
